var path = 'app/scripts/modules/core/src/subnet/subnetTag.component.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;